import { combineReducers } from 'redux';
import auth from './auth/authReducer';
import { reducer as resize } from './resizeModule';
import { reducer as resizeVolume } from './resizeVolumeModule';
import WHM from './WHM/whmReducer';
import { reducer as reboot } from './power/rebootModule';
import { reducer as reset } from './power/resetModule';
import { reducer as availableFlavors } from './availableFlavorsModule';
import { reducer as availableStorage } from './availableStorageModule';
import { reducer as update } from './updateModule';
import { reducer as vncConsole } from './vncConsoleModule';
import { reducer as availableConfigs } from './availableConfigsModule';

export default combineReducers({
	auth,
	availableConfigs,
	availableFlavors,
	availableStorage,
	reboot,
	reset,
	resize,
	resizeVolume,
	update,
	vncConsole,
	WHM,
});
